import { Navigate, useSearchParams } from 'react-router-dom';

export function RedirectAccount() {
  const [params] = useSearchParams();
  const next = new URLSearchParams(params);
  if (!next.get('view')) next.set('view', 'credits');
  return <Navigate to={`/dashboard?${next.toString()}`} replace />;
}

export function RedirectProjects() {
  return <Navigate to="/dashboard?view=projects" replace />;
}

export function RedirectNewProject() {
  return <Navigate to="/dashboard?view=projects" replace />;
}
